export default __webpack_public_path__ + "static/media/business-dashboard.168273b3.svg";